import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = logged in
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setChecked(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    // Challenge response = { mfa_required: true } only (no user id). A pending
    // non-enrolled sensitive user returns the full user (has id) + mfa_pending.
    if (data && data.mfa_required && !data.id) return { challenge: true };
    setUser(data);
    return data;
  };

  const verifyMfa = async (code) => {
    const { data } = await api.post("/auth/mfa/verify", { code });
    setUser(data);
    return data;
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(false);
  };

  const hasRole = (...roles) => {
    if (!user || !user.roles) return false;
    if (user.roles.includes("super_admin")) return true;
    return roles.some((r) => user.roles.includes(r));
  };

  return (
    <AuthContext.Provider value={{ user, checked, login, verifyMfa, refreshUser, logout, hasRole, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
